import dotenv from 'dotenv'
dotenv.config()

export default class Configuration {
  static get CONFIG () {
    return {
      appBasePath: '$VUE_APP_BASE_PATH',
      app: '$VUE_APP_APP',
      env: '$VUE_APP_ENV',
      url: '$VUE_APP_URL',
      subDomain: '$VUE_APP_SUB_DOMAIN',
      gateway: '$VUE_APP_GATEWAY_SUFFIX',
      theme: '$VUE_APP_THEME',
      awsPublicUrl: '$VUE_APP_AWS_PUBLIC_URL',
      gtm: '$VUE_APP_GTM',
      gtm4: '$VUE_APP_GTM4',
      hotjarId: '$VUE_APP_HOTJAR_ID',
      lang: '$VUE_APP_LANG',
      country: '$VUE_APP_COUNTRY',
      secret: '$VUE_APP_SECRET',
      aivo: '$VUE_APP_AIVO',
      name: '$VUE_APP_NAME',
      redsys: '$VUE_APP_REDSYS_URL',
      paypalID: '$VUE_APP_PAYPAL_ID',
      satisfactionSurveyURL: '$VUE_APP_SATISFACTION_SURVEY_URL',
      thankYouURL: '$VUE_APP_THANK_YOU_URL'
    }
  }

  static value (name) {
    if (!(name in this.CONFIG)) {
      //console.log(`Configuration: There is no key named "${name}"`)
      return
    }

    const value = this.CONFIG[name]

    if (!value) {
      //console.log(`Configuration: Value for "${name}" is not defined`)
      return
    }

    if (value.startsWith('$VUE_APP_')) {
      const envName = value.substr(1)
      // eslint-disable-next-line no-process-env
      const envValue = process.env[envName]
      if (envValue) {
        return envValue
      } else {
        //console.log(`Configuration: Environment variable "${envName}" is not defined`)
      }
    } else {
      return value
    }
  }
}